import { SUB_ANCHOR_MAP } from '../../constants'

export const FIELD = {
  QUANTITY: 'quantity',
  ITEM_QUANTITY: 'itemQuantity',
  AMOUNT: 'amount',
  NOTIFY_QUANTITY: 'notifyQuantity',
  TAG_QUANTITY: 'tagQuantity',
  YESTERDAY_QUANTITY: 'yesterdayQuantity',
  ABANDONED_CART_QUANTITY: 'abandonedCartQuantity',
  PAGE_VIEW_30D: 'pageView30d'
}

export const FIELD_MAP = {
  [FIELD.QUANTITY]: '未結帳賣場數',
  [FIELD.ITEM_QUANTITY]: '總訂購量',
  [FIELD.AMOUNT]: '訂購金額',
  [FIELD.NOTIFY_QUANTITY]: '貨到通知次數',
  [FIELD.TAG_QUANTITY]: '被收藏次數',
  [FIELD.YESTERDAY_QUANTITY]: '昨日加入購物車數',
  [FIELD.ABANDONED_CART_QUANTITY]: '未結帳賣場數',
  [FIELD.PAGE_VIEW_30D]: '前30天瀏覽量'
}

export const QUANTITY_TYPE_FIELD_MAP = {
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link]: [FIELD.QUANTITY],
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE.link]: [FIELD.NOTIFY_QUANTITY],
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM.link]: [FIELD.TAG_QUANTITY]
}

export const SORT_OPTIONS = {
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link]: [
    {
      id: FIELD.QUANTITY,
      value: FIELD.QUANTITY,
      text: FIELD_MAP[FIELD.QUANTITY]
    },
    {
      id: FIELD.YESTERDAY_QUANTITY,
      value: FIELD.YESTERDAY_QUANTITY,
      text: FIELD_MAP[FIELD.YESTERDAY_QUANTITY]
    },
    {
      id: FIELD.AMOUNT,
      value: FIELD.AMOUNT,
      text: FIELD_MAP[FIELD.AMOUNT]
    }
  ],
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE.link]: [
    {
      id: FIELD.NOTIFY_QUANTITY,
      value: FIELD.NOTIFY_QUANTITY,
      text: FIELD_MAP[FIELD.NOTIFY_QUANTITY]
    },
    {
      id: FIELD.AMOUNT,
      value: FIELD.AMOUNT,
      text: FIELD_MAP[FIELD.AMOUNT]
    }
  ],
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM.link]: [
    {
      id: FIELD.TAG_QUANTITY,
      value: FIELD.TAG_QUANTITY,
      text: FIELD_MAP[FIELD.TAG_QUANTITY]
    },
    {
      id: FIELD.AMOUNT,
      value: FIELD.AMOUNT,
      text: FIELD_MAP[FIELD.AMOUNT]
    }
  ]
}

export const SORT_MAP = {
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ABANDONEDCARTS.link]: {
    [FIELD.QUANTITY]: 'abandonedCartQuantity',
    [FIELD.YESTERDAY_QUANTITY]: 'abandonedCartYesterdayQuantity',
    [FIELD.AMOUNT]: 'abandonedCartAmount'
  },
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_ARRIVALNOTICE.link]: {
    [FIELD.NOTIFY_QUANTITY]: 'notifyQuantity',
    [FIELD.AMOUNT]: 'amount'
  },
  [SUB_ANCHOR_MAP.CUSTOMER_INTEREST_TRACKITEM.link]: {
    [FIELD.TAG_QUANTITY]: 'tagQuantity',
    [FIELD.AMOUNT]: 'amount'
  }
}

export const RES_TYPE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  DISCOUNT_COUNT_ZERO: 'DISCOUNT_COUNT_ZERO'
}

export const FILTER_NOTE = '自動濾除已停售賣場'
